<div class="row">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-12">
        <p class="text-primary-color text-center">Escolha o formato para exportar e clique para fazer o download</p>
      </div>
      <div class="col-sm-12 text-center mt-3">
        <button nz-button nzType="primary" type="button" [nzSize]="'large'" nz-popover
                  nzPopoverContent="Exportar Excel" (click)="exportarExcel()">
          <span nz-icon nzType="file-excel" nzTheme="outline"></span>
        </button>
        <!-- <button nz-button nzType="primary" type="button" [nzSize]="'large'" class="mx-4" nz-popover
                  nzPopoverContent="Exportar Word" (click)="exportarWord()">
          <span nz-icon nzType="file-word" nzTheme="outline"></span>
        </button> -->
        <button nz-button nzType="primary" type="button" [nzSize]="'large'" nz-popover
                  nzPopoverContent="Exportar Pdf" (click)="exportarPdf()">
          <span nz-icon nzType="file-pdf" nzTheme="outline"></span>
        </button>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-center">
        <button nz-button nzType="default" type="button" class="px-5" (click)="fecharModal()">Cancelar</button>
      </div>
    </div>
  </div>
</div>
